<template>
  <div class="personality_estimation">
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <div class="text-h6 mt-6 text-sm-h3">MBTI 性格推定</div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <v-textarea
            v-model="sentence"
            label="テキストを入力"
            counter
            maxlength="400"
            full-width
            single-line
          ></v-textarea>
        </v-col>
        <v-col cols="12" align="center">
          <v-btn @click="post(sentence)" elevation="2" x-large>推定</v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="showResult">
        <h1>推定結果：{{ this.result }}</h1>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PersonalityEstimation",
  data: () => ({
    sentence: "",
    result: "",
    result_ie: 0,
    result_ns: 0,
    result_tf: 0,
    result_jp: 0,
    showResult: false,
  }),
  methods: {
    post: function (sentence) {
      const endpoint = "http://127.0.0.1:5000/single_sentence_estimate";

      window.$.ajax({
        type: "POST",
        url: endpoint,
        dataType: "json",
        data: {
          sentence: sentence,
        },
        success: (data) => {
          this.result_ie = data.ie;
          this.result_ns = data.ns;
          this.result_tf = data.tf;
          this.result_jp = data.jp;
          this.showResult = true;

          this.result = "";
          var items = [];
          if (this.result_ie <= 0.5) {
            items.push("I");
          } else {
            items.push("E");
          }
          if (this.result_ns <= 0.5) {
            items.push("N");
          } else {
            items.push("S");
          }
          if (this.result_tf <= 0.5) {
            items.push("T");
          } else {
            items.push("F");
          }
          if (this.result_jp <= 0.5) {
            items.push("J");
          } else {
            items.push("P");
          }

          items.forEach((i) => {
            this.result += i;
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.info {
  text-align: center;
}

.heading {
  border-bottom: 2px solid #000;
}
</style>